import React from 'react'
import { Grid, withStyles } from '@material-ui/core'
import Main from '../Main/'
import Paper from 'components/theme/Paper'
import ContactInfo from '../ContactInfo'
// import Tasks from '../Tasks'
import Groups from '../Groups/'
import CustomAttributes from '../CustomAttributes'
import language from 'utils/vast-languagepack'
import Activities from '../Activities'
// import StartAConversation from '../StartAConversation'
// import InboxButton from '../Main/InboxButton'
// import UserAssignment from '../UserAssignment'

const DesktopForm = ({ classes, inbox, contactID }) => (
	<div style={{ maxWidth: 857, margin: '0 auto' }}>
		<div style={{ marginBottom: 20 }}>
			<Main inbox={inbox} contactID={contactID} />
		</div>
		<Grid container spacing={24}>
			<Grid item xs={7}>
				<Grid container spacing={24}>
					{/* <Grid item xs={12}>
						<Paper style={{ position: 'relative' }} className={classes.paper}>
							<div className={classes.title}>Start a conversation</div>
							<div style={{ position: 'absolute', top: 7, right: 7 }}>
								<InboxButton />
							</div>
						</Paper>
					</Grid> */}
					<Grid item xs={12}>
						<Paper className={classes.paper}>
							<div className={classes.title}>
								{language.contacts.add.groups}
							</div>
							<Groups />
						</Paper>
					</Grid>
					<Activities />
				</Grid>
			</Grid>
			<Grid item xs={5}>
				<Grid container spacing={24}>
					<Grid item xs={12}>
						<Paper className={classes.paper}>
							<div className={classes.title}>
								{language.contacts.add.contactInfo}
							</div>
							<ContactInfo />
						</Paper>
					</Grid>
					{/* <Grid item xs={12}>
						<Paper className={classes.paper}>
							<div className={classes.title}>User assignment</div>
							<UserAssignment />
						</Paper>
					</Grid> */}
					<Grid item xs={12}>
						<Paper className={classes.paper}>
							<div className={classes.title}>
								{language.contacts.add.customAttributes}
							</div>
							<CustomAttributes />
						</Paper>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	</div>
)

export default withStyles(theme => ({
  paper: {
    backgroundColor: '#fff',
    border: '1px solid #adadad',
    padding: 20,
    boxShadow: 'none',
  },
  title: { fontSize: 20 },
}))(DesktopForm)
